// extracted by mini-css-extract-plugin
module.exports = {"tabTitles":"styles_tabTitles__4DOvN","tabContentTitle":"styles_tabContentTitle__9bAhk","tabContentList":"styles_tabContentList__M3yOB"};
module.exports.__checksum = "33585ca2692f"